<template>
  <footer class="pt-2 my-md-5 pt-md-5 border-top">
    <div class="row">
      <div class="col-12 col-md">
        <img class="mb-5 mt-2" src="https://silversky.dev/img/logo.svg" alt="silversky logo" height="80">
      </div>
      <div class="col-6 col-md">
        <h5>Market Data</h5>
        <ul class="list-unstyled text-small">
          <li><a class="text-muted" href="https://duckduckgo.com/?q=!ducky+FX+rates+wiki" target="_blank">FX Rates</a></li>
          <li><a class="text-muted" href="https://duckduckgo.com/?q=!ducky+crypto+currencies+wiki" target="_blank">Crypto Rates</a></li>
          <li><a class="text-muted" href="https://duckduckgo.com/?q=!ducky+stock+quotes+wiki" target="_blank">Stock Quotes</a></li>
          <li><a class="text-muted" href="https://duckduckgo.com/?q=!ducky+gold+wiki" target="_blank">Gold Price</a></li>
        </ul>
      </div>
      <div class="col-6 col-md">
        <h5>Other Data</h5>
        <ul class="list-unstyled text-small">
          <li><a class="text-muted" href="https://duckduckgo.com/?q=!ducky+random+value+wiki" target="_blank">Random data</a></li>
          <li><a class="text-muted" href="https://duckduckgo.com/?q=!ducky+coinflip+wiki" target="_blank">Coin Flip</a></li>
        </ul>
      </div>
      <div class="col-6 col-md">
        <h5>About</h5>
        <ul class="list-unstyled text-small mb-5">
          <li><a class="text-muted" href="https://silversky.ch">Our Company</a></li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
